import React, { Component } from "react";
import Navbar from "../Navbars/Navbar";
import Footer from "components/Footers/Footer";
import "assets/css/safexpay-web.css";
import "../Policy/Policy.css";

class ResponsibleDisclosurePolicy extends Component {
  righthandler = () => {
    document.addEventListener('contextmenu', event => event.preventDefault());
    }
    
    componentDidMount() {
      this.righthandler();
    }
  render() {
    return (
      <>
        <Navbar />
        <main ref="main" className="dv-main">
          <section
            className="dv-HeroBanner dv-Policy"
            data-aos="fade-up"
            data-aos-duration="1000"
          >
            <h1 className="herobanner-heading text-center pt-5 font-w6">
              Responsible Disclosure Policy
            </h1>
          </section>
          <section className="dv-Policy-content font-s19">
            <div
              className="container"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              <div className="row">
                <div className="col-12">
                  <p>
                    Safexpay has great concern for the security of its platform,
                    application, and services which we are offering to our
                    customers. If you are a security researcher and have
                    discovered a security vulnerability in one of our services,
                    we appreciate your help in disclosing it to us in a
                    responsible manner. We will validate and fix vulnerabilities
                    in accordance with our policies. Safexpay reserves all its
                    legal rights in the event of any noncompliance to the
                    applicable laws and regulations.
                  </p>
                  <p>
                  <strong>REPORTING:</strong>
                  </p>
                  <p>
                    If you discover a vulnerability, we would like to know about
                    it, so we can take steps to address it as quickly as
                    possible. We would like to ask you to help us better protect
                    our clients and our systems.
                  </p>
                  <br />
                  <p>Please provide following information with your report:</p>
                  <br />
                  <p>
                    E-mail your findings to{" "}
                    <b style={{ textDecoration: "underline" }}>
                      infosec@Safexpay.com/legal@Safexpay.com.
                    </b>{" "}
                    The researcher should report us the detail step and
                    description to reproduce the vulnerability (This includes
                    screenshot, scripts, video, simple text instruction)
                  </p>
                  <br />
                  <p>
                    Encrypt and share your findings to prevent this critical
                    information from falling into the wrong hands, the
                    encryption and sharing mechanism will be provided once the
                    email contents are validated.
                  </p>
                  <br />
                  <p style={{ textDecoration: "underline" }}>
                    The encryption will involve a PGP key to encrypt the
                    contents and a file hash has to be provided to verify the
                    shared data integrity. The data will be shared only on our
                    official email address mentioned above
                  </p>
                  <br />
                  <p>Your email Id.</p>
                  <p>
                  <strong style={{ textDecoration: "underline" }}>
                    RULES FOR FINDING SECURITY VULNERABILITIES
                  </strong>
                  </p>
                  <ul>
                    <li>
                      Take responsibility and act with extreme care and caution.
                    </li>
                    <li>
                      When investigating the matter, only use methods or
                      techniques that are compliant with law and necessary in
                      order to find or demonstrate the weaknesses. Without
                      limiting the generality of the foregoing.
                    </li>
                    <li>
                      Do not take an advantage of the vulnerability or problem
                      you have discovered, for example by downloading more data
                      than necessary to demonstrate the vulnerability or
                      deleting or modifying other people's data.
                    </li>

                    <li>
                      Not allow to reveal the bug/vulnerability on online or
                      physical platform or anywhere else until it has been
                      resolved and prior written approval from Safexpay.
                    </li>
                    <li>
                      Do not use attacks on physical security, social
                      engineering, distributed denial of service, spam or
                      applications of third parties, and
                    </li>
                    <li>
                      Do provide sufficient information to reproduce the
                      problem, so we will be able to resolve it as quickly as
                      possible. Usually, the IP address or the URL of the
                      affected system and a description of the vulnerability
                      will be sufficient, but complex vulnerabilities may
                      require further explanation.
                    </li>
                    <li>
                      You represent and warrant that you have the right, title
                      and interest to disclose any vulnerability found and to
                      submit any information, including documents, codes, among
                      others, in connection therewith. You agree that, once you
                      inform a vulnerability, you grant Safexpay, its
                      subsidiaries and /or affiliates an irrevocable, worldwide,
                      royalty-free, transferable, sublicensable right to use in
                      any way Safexpay deems appropriate for any purpose
                      includes but not limited to reproduction, modification,
                      distribution, adaptation among other uses, the information
                      related with the vulnerabilities. Further, you hereby
                      waive all other claims of any nature, including express
                      contract, implied-in-fact contract, or quasi-contract,
                      arising out of any disclosure accepted by Safexpay.
                    </li>
                  </ul>
                  <p style={{ textDecoration: "underline" }}>
                    <b>
                      The following are excluded from the Responsible Disclosure
                      Policy (note that this list is not exhaustive):
                    </b>
                  </p>
                  <ul>
                    <li>
                      Taking any action that will negatively affect Safexpay,
                      its subsidiaries or agents.
                    </li>
                    <li>
                      Retaining any personally identifiable information
                      discovered, in any medium. Any personally identifiable
                      information discovered must be permanently destroyed or
                      deleted from your device and storage.
                    </li>
                    <li>
                      Disclosing any personally identifiable information
                      discovered to any third party.
                    </li>
                    <li>
                      Destruction or corruption of data, information or
                      infrastructure, including any attempt to do so.
                    </li>
                    <li>
                      Discovery dependent on social engineering techniques of
                      any kind (any verbal or written interaction with anyone
                      affiliated with or working for Safexpay).
                    </li>
                    <li>
                      Any exploitation actions, including accessing or
                      attempting to access Safexpay data or information, beyond
                      what is required for the initial Proof of Vulnerability.
                      This means your actions to obtain and validate the Proof
                      of Vulnerability must stop immediately after initial
                      access to the data or a system.
                    </li>
                    <li>Attacks on third-party services.</li>
                    <li>
                      Denial of Service attacks or Distributed Denial of
                      Services attacks.
                    </li>
                    <li>
                      Any attempt to gain physical access to Safexpay property
                      or data centers or planting ransomware, malware, spam,
                      crypto miners, zero day vulnerabilities etc.
                    </li>
                    <li>
                      Use of assets that you do not own or are not authorised or
                      licensed to use when discovering a vulnerability.
                    </li>
                    <li>
                      Violation of any laws or agreements in the course of
                      discovering or reporting any vulnerability.
                    </li>
                  </ul>
                  <p style={{ textDecoration: "underline" }}>
                    <b>
                      <u>Out of scope vulnerabilities</u>
                    </b>
                  </p>
                  <ul>
                    <li>
                      Vulnerabilities identified with automated tools (including
                      web scanners) that do not include proof-of-concept code or
                      a demonstrated exploit.
                    </li>
                    <li>
                      Third-party applications, websites or services that
                      integrate with or link Safexpay.
                    </li>
                    <li>
                      Discovery of any in-use service (vulnerable third-party
                      code, for example) whose running version includes known
                      vulnerabilities without demonstrating an existing security
                      impact.
                    </li>
                    <li>Known issues</li>
                  </ul>
                  <p style={{ textDecoration: "underline" }}>
                    <b>Examples of vulnerabilities include, inter alia:</b>
                  </p>
                  <ul>
                    <li>Authentication flaws</li>
                    <li>
                      Circumventing of platform and/or privacy permissions
                    </li>
                    <li>Privilege escalations</li>
                    <li>Cross-site scripting (XSS)</li>
                    <li>Cross-site request forgery (CSRF)</li>
                    <li>Server-Side request forgery (XSRF)</li>
                    <li>Injection Attacks (SQL, XML, Json, etc)</li>
                    <li>Business logic Bypass</li>
                    <li>Arbitrary redirect</li>
                    <li>Server-side code execution (RCE)</li>
                  </ul>
                  <p style={{ textDecoration: "underline" }}>
                    <b>In any event, please refrain from the following:</b>
                  </p>
                  <ul>
                    <li>
                      Do not use weaknesses you discover for purposes other than
                      your own investigation.
                    </li>
                    <li>
                      Do not use social engineering to gain access to a system.
                    </li>
                    <li>
                      Do not install any back doors not even to demonstrate the
                      vulnerability of a system.
                    </li>
                    <li>Back doors will weaken the systems security.</li>
                    <li>
                      Do not alter or delete any information in the system. If
                      you need to copy information for your investigation never
                      copy more than you need. If one record is sufficient, do
                      not go any further.
                    </li>

                    <li>Do not alter the system in any way.</li>
                    <li>
                      Do not share access or details of any vulnerable system
                      with others.
                    </li>
                    <li>
                      Do not use brute force techniques, such as repeatedly
                      entering passwords, to gain access to systems.
                    </li>
                  </ul>
                  <p style={{ textDecoration: "underline" }}>
                    <b>Also refrain from</b>
                  </p>
                  <ul>
                    <li>
                      Accessing, Downloading, or Modifying data residing in an
                      account that does not belong to you or attempt to do any
                      of the foregoing
                    </li>

                    <li>
                      Executing or attempting to execute any Denial of Service
                      attack
                    </li>
                    <li>
                      Posting, transmitting, uploading, linking to, sending, or
                      storing any malicious software;
                    </li>
                    <li>
                      Testing in a manner that would result in the sending
                      unsolicited or unauthorized junk mail, spam, pyramid
                      schemes, or other forms of duplicative or unsolicited
                      messages;
                    </li>
                    <li>
                      Testing in a manner that would degrade the operation of
                      any Safexpay properties; or testing third-party
                      applications, websites, or services that integrate with or
                      link to Safexpay properties.
                    </li>

                    <li>Issues with out-dated or unpatched browsers</li>
                    <li>Lack of the Secure flag on non-sensitive cookies</li>
                    <li>Lack of the HTTP Only flag on non-sensitive cookies</li>
                    <li>
                      Security vulnerabilities in third-party websites and
                      applications that integrate with issues
                    </li>
                    <li>
                      Vulnerabilities requiring a potential victim to install
                      nonstandard software or otherwise take steps to become
                      susceptible to attack
                    </li>
                    <li>
                      Social engineering of vulnerabilities requiring very
                      unlikely user interactions
                    </li>
                    <li>
                      Findings primarily from social engineering (e.g.,
                      phishing, vishing)
                    </li>
                    <li>
                      Findings from physical testing such as office access
                      (e.g., open doors, tailgating)
                    </li>
                    <li>UI/UX bugs and spelling mistakes</li>
                    <li>Spamming</li>
                    <li>
                      Disclosure of known public files or directories, (e.g.
                      robots.txt)
                    </li>
                    <li>
                      Click-jacking and issues only exploitable through
                      click-jacking
                    </li>
                    <li>
                      CSRF on forms that are available to anonymous users (e.g.
                      the contact form)
                    </li>
                    <li>Logout Cross-Site Request Forgery (logout CSRF)</li>
                    <li>
                      Presence of application or web browser autocomplete or
                      save password functionality
                    </li>
                    <li>
                      SSL Attacks such as BEAST, BREACH, Renegotiation attack
                    </li>
                    <li>SSL Forward secrecy not enabled</li>
                    <li>SSL Insecure cipher suites</li>
                    <li>
                      The Anti-MIME-Sniffing header X-Content-Type-Options
                    </li>
                    <li>Missing HTTP security headers</li>
                  </ul>
                  <p style={{ fontWeight: "bold" }}>POINTS TO KEEP IN MIND:</p>
                  <ul>
                    <li>
                      Do not put any customer or Safexpay data at risk, degrade
                      any of our systems performance.
                    </li>
                    <li>
                      If your actions are intrusive or an attack on our system,
                      we may act against the same including reporting them to
                      law enforcement agencies.
                    </li>
                    <li>
                      Safexpay reserves its right to initiate legal action
                      against any person and/or report to relevant authorities
                      of such person who conduct any Tests or investigations
                      which are prohibitive or not in compliance with law or not
                      as per this Policy.
                    </li>
                    <li>
                      Keep information about any vulnerabilities you've
                      discovered confidential between yourself and Safexpay. We
                      agree not to pursue legal action against individuals or
                      companies who submit vulnerability reports through our
                      requested channel and who comply with the requirements of
                      this policy unless we are compelled to do so by a
                      regulatory authority, other third party, or applicable
                      laws.
                    </li>
                  </ul>
                  <p>INDEMNIFICATION</p>
                  <p>
                    The Researcher shall fully indemnify, hold harmless and
                    defend (collectively “indemnify” and “indemnification”)
                    Safexpay, its subsidiaries and affiliates, its directors,
                    officers, employees, agents, and stockholders (collectively,
                    “Indemnified Parties”) from and against all claims, demands,
                    actions, suits, damages, liabilities, losses, settlements,
                    judgments, costs and expenses (including but not limited to
                    reasonable attorney’s fees and costs), whether or not
                    involving a third party claim, which arise out of or relate
                    to:{" "}
                  </p>
                  <p>
                    Any breach of any representation or warranty contained in
                    this Responsible Disclosure Policy made by the researcher;
                  </p>
                  <p>
                    {" "}
                    Any breach or violation of the terms of this Responsible
                    Disclosure Policy or any obligation/duty of researcher
                    referred therein or under applicable law; <br /> Any misuse
                    of data, including personal data; <br />
                    Any breach of the confidentiality or any waiver granted;{" "}
                    <br />
                    Any attempt to contact Safexpay’s clients, users or third
                    parties to disclose the existence of the vulnerability which
                    found including but not limited to any reference or message
                    in social media making reference to the finding; <br />
                    If any attempt to bring direct or indirectly claims,
                    demands, actions judgments, lawsuits against Safexpay or any
                    other Indemnified Party, in each case whether or not caused
                    by the negligence of Safexpay or any other Indemnified Party
                    and whether or not the relevant claim has merit.
                  </p>
                  <p>
                    We do not publicly announce the vulnerability found under
                    this program, failing which shall be liable for legal
                    penalty. We appreciate to get in touch with us and give us
                    the time to examine the issue. The safety of our customers’
                    information and assets is our top priority. Therefore, we
                    encourage anyone, who have discovered a vulnerability in our
                    systems to act instantly and help us improve and strengthen
                    the safety of our sites and systems.
                  </p>
                  <br /> <br />
                  <p
                    style={{ fontWeight: "bold", textDecoration: "underline" }}
                  >
                    OUR RECOGNITION
                  </p>
                  <p style={{ textDecoration: "underline" }}>
                    We currently do not provide any compensation or gifts for
                    reporting vulnerabilities. However, we are glad to express
                    our gratitude for genuine and ethical disclosures, we would
                    be glad to publicly acknowledge your responsible disclosure.
                    We also try to make the confidential issue public after the
                    vulnerability is announced. Further, Demand for monetary
                    compensation will not be complied under this Responsible
                    Disclosure Policy.
                  </p>
                  <p>
                    If you identify a valid security vulnerability in compliance
                    with this Responsible Disclosure Policy, Safexpay shall –
                  </p>
                  <ul>
                    <li>Acknowledge receipt of your vulnerability report</li>
                    <li>Work with you to understand and validate the issue</li>
                    <li>
                      Address the risk as deemed appropriate by Safexpay team
                    </li>
                    <li>Work together to prevent cyber-crime.</li>
                  </ul>
                  <p>
                    Safexpay will review the submission to determine if the
                    finding is valid and has not been previously reported.
                    Publicly disclosing the submission details of any identified
                    or alleged vulnerability without express written consent
                    from Safexpay will deem the submission as noncompliant with
                    this Responsible Disclosure Policy
                  </p>
                  <br />
                  <p>
                    Safexpay reserves all of its rights, especially regarding
                    vulnerability discoveries that are not in compliance with
                    this Responsible Disclosure policy. This Responsible
                    Disclosure policy is dated 1st January 2021 and will be
                    periodically reviewed and updated; please bookmark this page
                    and check it for the latest version of the policy before
                    taking any action.
                  </p>
                </div>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </>
    );
  }
}

export default ResponsibleDisclosurePolicy;
